// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"dfd8fe27","455":"1b991356","857":"44f4b707","977":"5a4c08f0"}[chunkId] + ".chunk.js";
};